import { transport } from 'config/transport';

export function callApiGetSubjects(congDoanId, classId, month) {
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/${classId}/phieuthu/subjects`, { params: { month } });
}
